export { default } from './RemoteSells';



// WEBPACK FOOTER //
// ./src/scenes/RemoteSells/index.js